import styled from "styled-components";
import { MarkDownParagraph } from "../text/p";

export const FootNoteInfo = styled(MarkDownParagraph).attrs({ as: "div" })`
  display: flex;
  padding: 0;
`;
